module.exports = __webpack_public_path__ + "static/media/Ipod.bee39198.png";